import { commonService } from '.';

const getListEepBm = (body) => {
    return commonService.post('ListEEPManager', body);
};

export const listEEPManagerService = {
    getListEepBm
}